var CryptoJS = require("crypto-js");
//var pbkdf2 = require("pbkdf2.js");
var salt = "8758f47589fad0b3a9e67bb589d3c961";
var iv = "39684b6e000ae043e0238186be6339cb";
var password = "aesEncryptionKey";

var keySize = 128 / 32;
var iterationCount = 1000;

var AesUtil = function () {
  this.keySize = 128 / 32;
  this.iterationCount = 1000;
};
//export {AesUtil};

const generateKey = function (salt, passPhrase) {
  var key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
  return key;
};

export const encrypt = function (plainText) {
  console.log("text2encrypt", plainText);
  var key = generateKey(salt, password);
  //console.log("AesUtil::encrypt", "key", key.toString());
  var encrypted = CryptoJS.AES.encrypt(plainText, key, {iv: CryptoJS.enc.Hex.parse(iv)});
  var encoded = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  return encodeURIComponent(encoded);
};

export const decrypt = function (cipherText) {
  console.log("decrypt", cipherText);
  var key = generateKey(salt, password);
  var cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText),
  });
  var decrypted = CryptoJS.AES.decrypt(cipherParams, key, {iv: CryptoJS.enc.Hex.parse(iv)});
  return decrypted.toString(CryptoJS.enc.Utf8);
};
